// import Vue from 'vue'
import Router from 'vue-router'
import Account from './account'
import Review from './review'
import Other from './other'
import Resource from './resource'
import Learn from './learn'
import Clazz from './clazz'
import Monitor from './monitor'
export default new Router({
  // mode: 'history',
  routes: [
    Account,
    Other,
    Review,
    Resource,
    Learn,
    Clazz,
    Monitor,
    { path: '*', redirect: '/resource' }, /*默认跳转路由*/
  ]
})

Vue.use(Router);



// WEBPACK FOOTER //
// ./src/pages/pc/router/index.js